// extracted by mini-css-extract-plugin
module.exports = {"page":"SQ","account":"TQ","pdp":"UQ","cart":"VQ","brand":"WQ","cartModal":"XQ","checkout":"YQ"};